/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useState, useEffect} from "react";

import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";

import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";
import ApplicationRouterContext from "@Contexts/Router";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";
import {LOG_USER_OUT_ACTION} from "@Actions/Authentication";


import {Redirect} from "react-router-dom";


import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";
import BlockContentContainerComponent from "@Components/UI/Containers/Block";


import SettingsSMSCodeVerificationComponent from "@UIPages/Authenticated/Settings/_Parts/Verification";
import {useDispatch} from "react-redux";
import ApplicationApiContext from "@Contexts/Api";
import {Button, Col} from "react-bootstrap";
import ERROR_SYSTEM_MESSAGE_INTERFACE from "@Services/Application/Interfaces/_Messages/Errors";
import DEFAULT_REQUEST_HEADERS from "@Services/Interfaces/Http/Request/Headers";
import HTTP_ERROR_RESPONSE_INTERFACE from "@Services/Interfaces/Http/Response/Error";
import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import REST_API_REQUEST from "@Services/Utilities/Requests";
import CHANGE_MODAL_MESSAGE_ACTION from "@Actions/Interface/ChangeModalMessage";


type RemoveAccountPageProps = {};


export const SettingsRemoveAccountPageComponent: React.FC<RemoveAccountPageProps> = (): JSX.Element | null => {


    /** @const Global State Actions Dispatcher */
    const DISPATCHER = useDispatch();


    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state): ReturnType<any> => state?.authentication
    )?.loggedUser || null;

    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);


    /** @const {string} Global Rest Api Root URL Address */
    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;

    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const [USER_AUTHENTICATED_STATUS, SET_USER_AUTHENTICATED_STATUS] = useState<boolean>(false);

    const CHANGE_USER_AUTHENTICATED_STATUS = (response: any) => {
        if (response.OperationGUID) SET_USER_AUTHENTICATED_STATUS(true);
    }

    const [DELETE_USER_ACCOUNT_ERROR, SET_DELETE_USER_ACCOUNT_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);


    useEffect(() => {
        return () => {
            SET_USER_AUTHENTICATED_STATUS(false);
            SET_DELETE_USER_ACCOUNT_ERROR(null);
        };
    }, []);


    if (!LOGGED_USER || !LOGGED_USER?.userID) return <Redirect to={ROUTER.NOT_AUTHENTICATED.LOGIN.URL}/>;


    if (!ROUTER) return <Redirect to={"/404"}/>;


    if (!USER_AUTHENTICATED_STATUS) return <SettingsSMSCodeVerificationComponent verificationStatusHandler={CHANGE_USER_AUTHENTICATED_STATUS} />;


    const DELETE_ACCOUNT_HANDLER = async () => {

        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(true));

        try {

            const USER_REMOVE_RESPONSE = await REST_API_REQUEST(
                `${REST_API_URL}/User`,
                {UserId: LOGGED_USER?.userID},
                REST_API_REQUEST_TOKEN,
                "DELETE"
            );

            if (USER_REMOVE_RESPONSE.status === 204) {
                DISPATCHER(CHANGE_MODAL_MESSAGE_ACTION(`Konto zostało usunięte`, "SUCCESS"));
                DISPATCHER(LOG_USER_OUT_ACTION());
            } else {
                const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await USER_REMOVE_RESPONSE.json();
                SET_DELETE_USER_ACCOUNT_ERROR({ErrorCode: USER_REMOVE_RESPONSE.status, UserMessage: CONTENT?.UserMessage});
            }

        } catch (e) {
            SET_DELETE_USER_ACCOUNT_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"})
        }

        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));

    };


    return (
        <BlockContentContainerComponent cssClasses={"settings-page-account-component settings-page-view-component"}>

            <BlockContentHeaderComponent headerText={"Usuń konto"} />

            {!!DELETE_USER_ACCOUNT_ERROR &&
            <ErrorMessageComponent messageText={DELETE_USER_ACCOUNT_ERROR.UserMessage} />
            }

            {!DELETE_USER_ACCOUNT_ERROR &&
	        <Col xs={12} className={"no-list-elements-message default-system-message"}>
		        <span>{`Usunięcie konta jest nieodwracalne. Po usunięciu konta, aby ponownie używać aplikacji eKiosk należy się ponownie zarejestrować`}</span>
	        </Col>
            }

            {!DELETE_USER_ACCOUNT_ERROR &&
	        <Col xs={12} className={"submit-button-component operation-submit-button"}>
		        <Button onClick={DELETE_ACCOUNT_HANDLER}>
			        <span>{`Usuń konto`}</span>
		        </Button>
	        </Col>
            }

        </BlockContentContainerComponent>
    );

}


export default SettingsRemoveAccountPageComponent;
